
import {throwError,  Observable } from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { UtilitiesModel, UtilitiesGroupUtilityModel } from 'app/models/utilities.model';
import { ConfigService } from '../../services/config.service';
import { SurveyQuestionModel, SurveyQuestionResponseModel } from 'app/core/models/survey-question-response.model';

@Injectable()
export class SurveyResponseService {

    constructor(private http: HttpClient, private config: ConfigService) {

    }

    public GetSurveyQuestion(survey_question_id: string): Observable<SurveyQuestionModel> {
      return this.http.get<SurveyQuestionModel>(this.config.getApiRoute('api/v3/customer-portal/survey/questions/' + survey_question_id)).pipe(
          map(data => {
              return data;
          }),
          catchError((err: HttpErrorResponse) => {
              return throwError(err.error.message);
          }));
  }

    public PutSurveyResponse(argument: SurveyQuestionResponseModel): Observable<SurveyQuestionResponseModel> {
        return this.http.put<SurveyQuestionResponseModel>(this.config.getApiRoute('api/v3/customer-portal/survey/survey-response'), argument).pipe(
            map(data => {
                return data;
            }),
            catchError((err: HttpErrorResponse)  => {
                return throwError(err.error.message);
            }),);

    }

}
